import React from 'react'
import Header from '../header/HeaderFour';
import Breadcrumb from '../inner/Breadcrumb';
import Footer from '../elements/Footer';
import Accordion from 'react-bootstrap/Accordion';




function tax() {
  return (
    <div className='tax'>
        <div className="">
            <Header/>
            <main>
                <Breadcrumb title="TAX" sub_title="Service" active="TAX"/>
                    {/* tmp service section */}
                    <div className="tmp-service-section tmp-section-gap">
                        <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                            <div className="tmp-large-service-detials">
                                <img
                                src="assets/images/services/tax.jpg"
                                alt="business formation"
                                />
                            </div>
                            {/* single service details component */}
                            <div className="single-service-details-component mt--40">
                                <h2 className="title split-collab">
                               Stress-Free Tax Preparation & Filing Services
                                </h2>
                                <p className="disc mb--20">
                               Take the stress out of Tax season with our Tax preparation and filing services. We make sure our clients are ready, confident and connected every step of the way. We work closely with you to ensure all your documents are in order, deductions are maximized and fillings are accurate and timely.
                                </p>
                            </div>
                            {/* single service details component end */}
                            <div className="row g-5 mt--10">
                                <div className="col-lg-6 col-md-6">
                                {/* single service large-details */}
                                <div className="single-service-details">
                                    
                                    <div className="information">
                                    <h6 className="title">Expert Tax Preparation for Personal and Business Needs</h6>
                                    <p className="disc">
                                      We offer a full range of tax services tailored to meet the needs of both individuals and businesses. Our personal and business tax return preparation ensures that your filings are accurate, timely, and optimized for every available deduction and credit. Whether you're self-employed, a small business owner, or managing multiple income streams, we take the time to understand your unique financial situation and provide the personalized support you need. Our goal is to simplify the filing process and help you keep more of what you earn.
                                    </p>
                                    </div>
                                </div>
                                {/* single service large-details end */}
                                </div>
                                <div className="col-lg-6 col-md-6">
                                {/* single service large-details */}
                                <div className="single-service-details">
                                    
                                    <div className="information">
                                    <h6 className="title">Year-Round Tax Compliance and Planning Solutions</h6>
                                    <p className="disc">
                                     In addition to return preparation, we handle sales tax filing and payroll tax reporting, helping you stay compliant with ever-changing regulations. We also provide year-round tax planning services, so you're not just reacting during tax season — you're preparing ahead to minimize liabilities and maximize savings. With our strategic guidance, you can make smarter financial decisions and reduce the risk of audits. Our proactive approach ensures you're always one step ahead, with accurate records and peace of mind throughout the year.
                                    </p>
                                    </div>
                                </div>
                                {/* single service large-details end */}
                                </div>
                            </div>
                            
                            <div className="row mt--10">
                                <div className="col-lg-12">
                                <div className="faq-accordion">

                                    <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                        <div className="accordion-button-left">
                                                <i className="fa-regular fa-question" />
                                                <span>What tax services do you provide?</span>
                                                </div>
                                                <div className="accordion-button-right">
                                                <i className="fa-sharp fa-light fa-arrow-right" />
                                                </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                               We offer comprehensive tax preparation, planning, and filing services for individuals and businesses. Our experts ensure accuracy, compliance, and maximum savings by leveraging all eligible deductions and credits.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>
                                            <div className="accordion-button-left">
                                                <i className="fa-regular fa-question" />
                                                <span>Can you help with year-round tax planning?</span>
                                                </div>
                                                <div className="accordion-button-right">
                                                <i className="fa-sharp fa-light fa-arrow-right" />
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                              Yes! We provide ongoing tax planning and advisory services to help you make smart financial decisions throughout the year — minimizing liabilities and avoiding last-minute surprises during tax season.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>
                                            <div className="accordion-button-left">
                                                <i className="fa-regular fa-question" />
                                                <span>
                                                  Do you handle both personal and business taxes?
                                                </span>
                                                </div>
                                                <div className="accordion-button-right">
                                                <i className="fa-sharp fa-light fa-arrow-right" />
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                                Absolutely. We manage personal, corporate, and partnership taxes, ensuring every return is filed correctly and on time while keeping you fully compliant with federal and state tax laws.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    </Accordion>

                                    <div className="faq-buttom">
                                    <h4 className="title">Still Have More Questions?</h4>
                                    <p>
                                                      Contact Our <a style={{color:"#F8E3E3"}} href="/contact-us">Expert Support Team</a>
                                    </p>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                            <div className="col-lg-4 pl--50 pl_md--15 pl_sm--10 mt_md--50 mt_sm--50">
                            <div className="side-bar-details-page">
                                
                                {/* single bar */}
                                <div className="signle-side-bar category-area">
                                <div className="header">
                                    <h3 className="title">Service List</h3>
                                </div>
                                <div className="body">
                                    {/* single category */}
                                    <a href="/business-formation" className="single-category">
                                    <p>Business Formation</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    {/* single category */}
                                    <a href="/payroll-management" className="single-category">
                                    <p>Payroll Management</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    {/* single category */}
                                    <a href="/book-keeping" className="single-category">
                                    <p>Book Keeping</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    {/* single category */}
                                    <a href="/business-consultation" className="single-category">
                                    <p>Business Consultation</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    
                                </div>
                                </div>
                                {/* single bar end */}
                                {/* single bar */}
                                <div className="signle-side-bar call-to-action">
                                <div className="easy-call-to-action">
                                    <div className="icon-center-call">
                                    <i className="fa-light fa-phone" />
                                    </div>
                                    <h3 className="title">Need any help?</h3>
                                    <p className="disc">
                                    We are here to help our customer any time. You can call on
                                    24/7 To Answer Your Question.
                                    </p>
                                    <a href="tel:8323510418">832-351-0418</a>
                                </div>
                                </div>
                                {/* single bar end */}
                                {/* single bar */}
                                {/* <div className="signle-side-bar brochure">
                                <div className="header">
                                    <h3 className="title">Brochure</h3>
                                </div>
                                <div className="body">
                                    
                                    <a href="#" className="single-brocher">
                                    <p>Investment Policy</p>
                                    <i className="fa-light fa-cloud-arrow-down" />
                                    </a>
                                    
                                    <a href="#" className="single-brocher">
                                    <p>Company Details</p>
                                    <i className="fa-light fa-note" />
                                    </a>
                                  
                                </div>
                                </div> */}
                                {/* single bar end */}
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    {/* tmp service section end */}
                <Footer/>
            </main>
        </div>
    </div>
  )
}

export default tax